<template>
  <b-card>
    <!-- Tabs with card integration -->
    <b-row
      ><b-col lg="12">
        <b-tabs v-model="tabIndex">
          <b-tab :title="$t('edu_programs.welcome_message')">
            <b-card class="border mb-0">
              <b-card-title>{{ welcome.title }}</b-card-title>
              <b-card-body v-html="welcome.description"> </b-card-body>
            </b-card>
          </b-tab>
          <b-tab title="فيديو تعريفى">
            <b-card class="border mb-0" v-if="youtube.data">
              <b-card-title>{{ youtube.title }}</b-card-title>
              <b-card-body v-html="youtube.description"> </b-card-body>
              <b-card-footer>
                <iframe
                 style="width: 100%" 
                  height="701"
                  :src="youtube.data"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </b-card-footer>
            </b-card>
            <b-card class="border mb-0" v-if="video.data">
              <b-card-title>{{ video.title }}</b-card-title>
              <b-card-body v-html="video.description"> </b-card-body>
              <b-card-footer>
                <video style="width: 100%" controls>
                  <source :src="video.data" type="video/mp4" />
                </video>
              </b-card-footer>
            </b-card>
          </b-tab>
          <b-tab title="ملف صوتي تعريفي">
            <b-card class="border mb-0">
              <b-card-title>{{ sound.title }}</b-card-title>
              <b-card-body v-html="sound.description"> </b-card-body>
              <b-card-footer>
                <audio controls style="width: 100%">
                  <source :src="sound.data" type="audio/ogg" />
                  <source :src="sound.data" type="audio/mpeg" />
                </audio>
              </b-card-footer>
            </b-card>
          </b-tab>
          <b-tab title="ملف pdf تعريفي">
            <b-card class="border mb-0">
              <b-card-title>{{ file.title }}</b-card-title>
              <b-card-body v-html="file.description"></b-card-body>
              <b-card-footer>
                <object
                  style="width: 100%; height: 80vh"
                  :data="file.data"
                  type="application/pdf"
                >
                  <embed
                    style="width: 100%; height: 80vh"
                    :src="file.data"
                    type="application/pdf"
                  />
                </object>
              </b-card-footer>
            </b-card>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col lg="12">
        <!-- Control buttons-->
        <div class="text-center">
          <b-button-group class="mt-1">
            <b-button variant="outline-primary" @click="tabIndex--">
              سابق
            </b-button>
            <b-button variant="outline-primary" @click="tabIndex++">
              التالي
            </b-button>
          </b-button-group>
        </div>
      </b-col></b-row
    >
  </b-card>
</template>

<script>
import Auth from "@/Apis/Auth";
export default {
  data() {
    return {
      tabIndex: 0,
      eduProgram: {},
      welcome: {},
      youtube: {},
      video: {},
      sound: {},
      file: {},
    };
  },
  created() {
    let id = localStorage.getItem("eduProgram");
    let eduProgram = Auth.EDU_PROGRAMS.find((a) => a.id == id);
    let welcome = eduProgram.details.find((a) => a.type == "welcome");
    let youtube = eduProgram.details.find((a) => a.type == "youtube");
    let video = eduProgram.details.find((a) => a.type == "video");
    let sound = eduProgram.details.find((a) => a.type == "sound");
    let file = eduProgram.details.find((a) => a.type == "file");
    if (welcome) this.welcome = welcome;
    if (youtube) this.youtube = youtube;
    if (video) this.video = video;
    if (sound) this.sound = sound;
    if (file) this.file = file;
  },
};
</script>

<style>
</style>